import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BarcodeFormat } from '@zxing/library';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-barcode-scanner',
  templateUrl: './barcode-scanner.component.html',
  styleUrls: ['./barcode-scanner.component.css']
})

export class BarcodeScannerComponent implements OnInit {

  sound = new Audio('/assets/barcode.wav');
  barcodeValue;
  scannerEnabled = true;
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;

  formatsEnabled: BarcodeFormat[] = [
    BarcodeFormat.CODE_128,
    BarcodeFormat.DATA_MATRIX,
    BarcodeFormat.EAN_13,
    BarcodeFormat.QR_CODE,
    BarcodeFormat.AZTEC,
    BarcodeFormat.CODE_39,
    BarcodeFormat.CODE_93,
    BarcodeFormat.EAN_8,
    BarcodeFormat.EAN_13,
    BarcodeFormat.ITF,
    BarcodeFormat.MAXICODE,
    BarcodeFormat.PDF_417,
  ];

  hasDevices: boolean;
  hasPermission: boolean;
  qrResultString: string;
  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = true;

  @Output() SaveEvent = new EventEmitter<string>();

  constructor(public dialogRef: MatDialogRef<BarcodeScannerComponent>) { }

  ngOnInit() {
    this.checkCameraPermission();
  }


  onStarted(started){
      console.log(started);
  }

  clearResult(): void {
    this.qrResultString = null;
  }

  // onCamerasFound(devices: MediaDeviceInfo[]): void {
  //   this.availableDevices = devices;
  //   this.hasDevices = Boolean(devices && devices.length);

  //   setTimeout(() => {
  //     for (const device of devices) {
  //       if (/back|rear|environment/gi.test(device.label)) {
  //         this.currentDevice = device;
  //         break;
  //        }
  //     }
  //   }, 1000);
  // }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
  this.availableDevices = devices;
  this.hasDevices = devices.length > 0;

  const rearCamera = devices.find(device =>
    /back|rear|environment/i.test(device.label)
  );

  this.currentDevice = rearCamera ?? devices[0]; // fallback to first
}

  onCodeResult(resultString: string) {       
    // alert(resultString);
    // console.log(resultString); 

     if(this.sound)
       this.sound.play();

    this.qrResultString = this.barcodeValue = resultString;
    this.SaveEvent.emit(resultString);
    this.dialogRef.close(true);
  }

  onDeviceSelectChange(selected: string) {
    const device = this.availableDevices.find(x => x.deviceId === selected);
    this.currentDevice = device || null;
  }

  openFormatsDialog() {
    const data = {
      formatsEnabled: this.formatsEnabled,
    };    
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
  }

  openInfoDialog() {
    const data = {
      hasDevices: this.hasDevices,
      hasPermission: this.hasPermission,
    };

  }

  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }

  toggleTryHarder(): void {
    this.tryHarder = !this.tryHarder;
  }

  checkCameraPermission() {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(stream => {
        console.log('Camera permission granted');
        this.hasPermission = true;
        // You can stop the stream after permission check
        stream.getTracks().forEach(track => track.stop());
      })
      .catch(err => {
        console.error('Camera permission denied: ', err);
        alert('Please grant camera access for scanner to work.');
      });
  }

}
